/**
 * Prepare packaged SVG XML for unclipped containd.space paint
 * (overflow visible + script/handler strip).
 */
export function prepareInlineCanvasSvg(
  raw: string,
  canvasWidth: number,
  canvasHeight: number,
): string | null {
  const trimmed = raw.trim();
  if (!trimmed || !/<svg[\s>]/i.test(trimmed)) return null;

  let xml = trimmed
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');

  const open = xml.match(/<svg\b[^>]*>/i);
  if (!open) return null;

  let openTag = open[0];
  if (/\boverflow\s*=/i.test(openTag)) {
    openTag = openTag.replace(
      /\boverflow\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/i,
      'overflow="visible"',
    );
  } else {
    openTag = openTag.replace(/<svg\b/i, '<svg overflow="visible"');
  }
  if (!/\bwidth\s*=/i.test(openTag)) {
    openTag = openTag.replace(/<svg\b/i, `<svg width="${canvasWidth}"`);
  }
  if (!/\bheight\s*=/i.test(openTag)) {
    openTag = openTag.replace(/<svg\b/i, `<svg height="${canvasHeight}"`);
  }

  xml = xml.replace(/<svg\b[^>]*>/i, openTag);
  return xml;
}
